module.exports = __webpack_public_path__ + "static/logo-ofx-674b83f03221773644b9e6e9ff5d8be1.png";